import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";

const Contact = () => {
  const { t } = useTranslation();

  const offices = [
    {
      title: t("contact.offices.headOffice.title"),
      address: t("contact.offices.headOffice.address"),
      phones: [
        {
          label: t("contact.offices.headOffice.phone1Label"),
          value: t("contact.offices.headOffice.phone1"),
          href: "tel:+902124154511",
        },
        {
          label: t("contact.offices.headOffice.phone2Label"),
          value: t("contact.offices.headOffice.phone2"),
          href: "tel:+902125474449",
        },
      ],
    },
    {
      title: t("contact.offices.branch.title"),
      address: t("contact.offices.branch.address"),
      phones: [
        {
          label: t("contact.offices.headOffice.phone1Label"),
          value: t("contact.offices.branch.phone"),
          href: "tel:+902126652872",
        },
        {
          label: t("contact.offices.headOffice.phone2Label"),
          value: t("contact.offices.headOffice.phone2"),
          href: "tel:+902126652872",
        },
      ],
    },
  ];

  return (
    <section className="container-page section">
      {/* Başlık */}
      <div className="page-head">
        <h1 className="page-title">{t("contact.title")}</h1>
        <p className="page-sub">{t("contact.subtitle")}</p>
      </div>

      {/* Ofisler */}
      <div className="grid gap-px overflow-hidden rounded-lg border border-line bg-line md:grid-cols-2">
        {offices.map((office, i) => (
          <div key={i} className="bg-white p-8">
            <h2 className="text-[17px] font-semibold text-ink">
              {office.title}
            </h2>

            <div className="mt-6 space-y-4 text-[14px]">
              <div className="flex items-start gap-3">
                <FiMapPin
                  className="mt-0.5 shrink-0 text-muted"
                  size={16}
                  aria-hidden="true"
                />
                <p className="text-body">{office.address}</p>
              </div>

              {office.phones.map((phone, j) => (
                <div key={j} className="flex items-start gap-3">
                  <FiPhone
                    className="mt-0.5 shrink-0 text-muted"
                    size={16}
                    aria-hidden="true"
                  />
                  <p className="text-body">
                    <span className="text-muted">{phone.label}: </span>
                    <a href={phone.href} className="text-ink hover:text-accent">
                      {phone.value}
                    </a>
                  </p>
                </div>
              ))}

              <div className="flex items-start gap-3">
                <FiMail
                  className="mt-0.5 shrink-0 text-muted"
                  size={16}
                  aria-hidden="true"
                />
                <p className="text-body">
                  <span className="text-muted">
                    {t("contact.offices.headOffice.emailLabel")}:{" "}
                  </span>
                  <a
                    href="mailto:akkuzey@hotmail.com"
                    className="text-ink hover:text-accent"
                  >
                    {t("contact.offices.headOffice.email")}
                  </a>
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Mağazalar Butonu */}
      <div className="mt-10">
        <Link to="/stores" className="btn-primary">
          {t("viewStores")}
        </Link>
      </div>
    </section>
  );
};

export default Contact;
